import type { FC, ReactNode } from 'react'

import { Seo } from '@/components/generals/seo'
import { Layout } from '@/components/generals/layout'
import { Hero } from '@/components/landing/hero'
import { TaskMarquee } from '@/components/landing/task-marquee'
import { FeatureTabs } from '@/components/landing/feature-tabs'
import { GrowthSection } from '@/components/landing/growth-section'
import { SafetySection } from '@/components/landing/safety-section'
import { AboutSection } from '@/components/landing/about-section'
import { ClosingSection } from '@/components/landing/closing-section'

const Home: FC = (): ReactNode => {
    return (
        <Layout>
            <Seo />

            <Hero />
            <TaskMarquee />
            <FeatureTabs />
            <GrowthSection />
            <SafetySection />
            <AboutSection />
            <ClosingSection />
        </Layout>
    )
}

export default Home
